import {
  ArrowDown,
  CircleCheck,
  ExternalLink,
  TriangleAlert,
} from 'lucide-react'
import { Link } from 'react-router'
import { CopyField } from '@/components/sv/copy-field'
import { Muted } from '@/components/sv/typographies'
import { Button } from '@/components/ui/button'

export type MigratingEndpoint = {
  id: string
  label?: string
  legacyEndpoint: string
  nextEndpoint: string | null
}

export type MigratingService = {
  id: string
  name: string
  href: string
  endpoints: MigratingEndpoint[]
}

type EndpointMigrationListProps = {
  services: MigratingService[]
  onNavigate: () => void
}

const EndpointRow = ({ endpoint }: { endpoint: MigratingEndpoint }) => (
  <li className="flex flex-col gap-1 text-sm">
    {endpoint.label ? (
      <span className="text-xs font-semibold">{endpoint.label}</span>
    ) : null}
    <div className="flex flex-wrap items-center gap-2">
      <span className="flex w-20 shrink-0 items-center gap-1 text-xs font-medium text-amber-900/70 dark:text-amber-50/70">
        <TriangleAlert aria-hidden="true" className="size-3.5" />
        Legacy
      </span>
      <CopyField value={endpoint.legacyEndpoint} size="sm" />
    </div>
    <ArrowDown
      aria-hidden="true"
      className="size-4 shrink-0 text-muted-foreground"
    />
    <div className="flex flex-wrap items-center gap-2">
      <span className="flex w-20 shrink-0 items-center gap-1 text-xs font-medium text-success">
        <CircleCheck aria-hidden="true" className="size-3.5" />
        New
      </span>
      {endpoint.nextEndpoint ? (
        <CopyField value={endpoint.nextEndpoint} size="sm" />
      ) : (
        <Muted className="text-xs italic">Not available yet</Muted>
      )}
    </div>
  </li>
)

export const EndpointMigrationList = ({
  services,
  onNavigate,
}: EndpointMigrationListProps) => (
  <ul className="flex flex-col gap-2">
    {services.map((service) => (
      <li
        key={service.id}
        className="flex flex-col gap-3 rounded-lg border border-border p-3"
      >
        <div className="flex items-center justify-between gap-2">
          <span className="truncate text-sm font-medium">{service.name}</span>
          <Button
            variant="outline"
            size="sm"
            className="h-7 shrink-0 px-2 text-xs"
            asChild
          >
            <Link to={service.href} onClick={onNavigate}>
              Networking
              <ExternalLink aria-hidden="true" className="size-3" />
            </Link>
          </Button>
        </div>
        <ul className="flex flex-col gap-3">
          {service.endpoints.map((endpoint) => (
            <EndpointRow key={endpoint.id} endpoint={endpoint} />
          ))}
        </ul>
      </li>
    ))}
  </ul>
)
